import React from "react";
import { Badge, Card, Table } from "react-bootstrap";
import type { DashboardAnalytics, DashboardRecentBooking } from "../../types/dashboard";

interface RecentBookingsProps {
  bookings: DashboardRecentBooking[];
  analyticsLoading: boolean;
  onRowClick: (booking: DashboardRecentBooking) => void;
}

const getStatusBadge = (status: string): string => {
  switch (status) {
    case "confirmed":
      return "success";
    case "pending":
      return "warning";
    case "cancelled":
      return "danger";
    default:
      return "secondary";
  }
};

const formatBookingDate = (iso: string): string => {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
};

const RecentBookings: React.FC<RecentBookingsProps> = ({
  bookings,
  analyticsLoading,
  onRowClick,
}) => {
  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Recent Bookings</h5>
      </Card.Header>
      <Card.Body>
        {analyticsLoading ? (
          <div className="text-center text-muted py-3">Loading…</div>
        ) : bookings.length === 0 ? (
          <div className="text-center text-muted py-3">No recent bookings.</div>
        ) : (
          <Table responsive hover className="mb-0">
            <thead>
              <tr>
                <th>Booking ID</th>
                <th>Customer</th>
                <th>Movie</th>
                <th>Cinema</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking) => (
                <tr
                  key={booking.id}
                  onClick={() => onRowClick(booking)}
                  style={{ cursor: "pointer" }}
                >
                  <td>
                    <code>{booking.bookingNumber}</code>
                  </td>
                  <td>{booking.customer}</td>
                  <td>{booking.movie}</td>
                  <td>{booking.cinema}</td>
                  <td className="text-success fw-medium">{booking.amount}</td>
                  <td>{formatBookingDate(booking.bookingDate)}</td>
                  <td>
                    <Badge bg={getStatusBadge(booking.status)}>
                      {booking.status}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default RecentBookings;